module.exports = __webpack_public_path__ + "img/bubble.e72e88f5.jpg";